import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export interface Tarea {
  id?: string; // si no lo tienes en la respuesta del backend, es opcional
  titulo: string;
  id_lista?: string;
  creado_por?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TareaService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  crearTarea(data: Tarea): Observable<any> {
    return this.http.post(`${this.baseUrl}tarea/crear/`, data);
  }

  listarTareasPorLista(lista_id: number): Observable<Tarea[]> {
    return this.http.get<Tarea[]>(`${this.baseUrl}tarea/listar/?lista_id=${lista_id}`);
  }

  editarTarea(data: Tarea): Observable<any> {
    return this.http.post(`${this.baseUrl}tarea/editar/`, data);
  }

  eliminarTarea(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}tarea/eliminar/`, { id });
  }

  actualizarListaTarea(payload: {
    tarea_id: string;
    nueva_lista_id: string;
    lista_origen_id: string;
    usuario_id: number;
  }): Observable<any> {
    return this.http.put(`${this.baseUrl}tarea/mover/`, payload);
  }
}
